import { CSSProperties } from "react";

type CssVars = {
  [key: `--${string}`]: string;
};

export function useCssVars(vars: CssVars) {
  return vars as CSSProperties;
}
